/** @format */

import OrdersAviationCreatePage from './OrdersAviationCreatePage';
export default OrdersAviationCreatePage;
